<app-title-ayuda-component [title]="pageTitle"></app-title-ayuda-component>
<div class="container">
  <span
    >{{ contactContent()?.firstPartOfContactDescription }}  
    <a href="{{ contactContent()?.linkToContactLabel }}">un mensaje </a
    >{{ contactContent()?.lastPartOfContactDescription }}</span
  >
</div>
